export default __webpack_public_path__ + "static/testimony-1-82a56047bb3cdbb82488c67e333fb522.jpg";